"use strict";
exports.__esModule = true;
exports.FilterQuery = void 0;
var field_1 = require("../field");
var filter_1 = require("../filter");
var FilterQuery = /** @class */ (function () {
    function FilterQuery(entity_type, conditions, fields, sorting, start, limit, query, // Mongodb query for backend only
    count_only) {
        if (sorting === void 0) { sorting = [new filter_1.Sorting(field_1.DefaultEntityFields.UPDATED_ON, filter_1.SortOrder.DESC)]; }
        this.entity_type = entity_type;
        this.conditions = conditions;
        this.fields = fields;
        this.sorting = sorting;
        this.start = start;
        this.limit = limit;
        this.query = query;
        this.count_only = count_only;
    }
    FilterQuery.fromJSON = function (json) {
        var entity_type = json.entity_type, conditions = json.conditions, fields = json.fields, sorting = json.sorting, start = json.start, limit = json.limit, query = json.query, count_only = json.count_only;
        return new FilterQuery(entity_type, conditions ? filter_1.FilterGroup.fromJSON(conditions) : null, fields, sorting.map(function (s) { return filter_1.Sorting.fromJSON(s); }), start, limit, query, count_only);
    };
    // Separate function to build sort options
    FilterQuery.buildSortOptions = function (sorting) {
        // Default sort: updated_on descending
        var defaultSort = { updated_on: -1 };
        // If no sorting provided, return default
        if (!sorting || sorting.length === 0) {
            return defaultSort;
        }
        // Build sort object from sorting array
        var sortObject = {};
        for (var _i = 0, sorting_1 = sorting; _i < sorting_1.length; _i++) {
            var sort = sorting_1[_i];
            if (sort.field && sort.order) {
                sortObject[sort.field] = sort.order === filter_1.SortOrder.ASC ? 1 : -1;
            }
        }
        // If no valid sort fields were found, return default
        if (Object.keys(sortObject).length === 0) {
            return defaultSort;
        }
        return sortObject;
    };
    return FilterQuery;
}());
exports.FilterQuery = FilterQuery;
// "sorting": [
//             {
//                 "field": "createdate",
//                 "order": "asc"
//             },
//             {
//                 "field": "hs_object_id",
//                 "order": "desc"
//             }
//         ],
